import React, { useRef, useState, useEffect } from 'react';

const InfoCard = ({
  image,
  startDate,
  endDate,
  buttonText,
  onButtonClick,
  boxes = [],
  showBoxColors = true,
  extraInfo = [],
}) => {
  const imgRef = useRef();
  const [isWide, setIsWide] = useState(false);
  const defaultColors = ['#fed6d6', '#fbfed6', '#d6fed6'];

  useEffect(() => {
    const img = imgRef.current;
    if (img) {
      img.onload = () => {
        const { naturalWidth, naturalHeight } = img;
        setIsWide(naturalWidth / naturalHeight > 4); 
      };
    }
  }, [image]);

  return (
    <div className="relative">
      <div className="bg-[#cfe3fb] p-4 rounded-xl shadow-[0px_4px_6px_rgba(0,0,0,0.4)] border-black-100">
        <div className="grid grid-cols-5 gap-4">
          <div className="flex flex-col items-center justify-center">
            <img
              ref={imgRef}
              src={image}
              alt="logo"
              className={isWide ? 'w-auto h-15 mb-2' : 'w-52 h-auto mb-2'}
            />

            <p className="text-[#033a88] font-semibold text-sm">Inicio: {startDate}</p>
            <p className="text-[#033a88] font-semibold text-sm">Termina: {endDate}</p>
          </div>

          {boxes.map((box, i) => (
            <div
              key={i}
              className="p-3 rounded-lg text-center"
              style={{
                backgroundColor: showBoxColors ? defaultColors[i] : '#eaf2fb',
              }}
            >
              <p className="font-bold text-[#033a88]">{box.title}</p>
              <p className="text-lg font-bold text-[#022351]">{box.value}</p>
              <p className="text-sm font-bold text-[#033a88]">{box.rate}</p>
            </div>
          ))}

          <div className="flex items-center justify-center">
            <button
              onClick={onButtonClick}
              className="bg-[#022351] text-white font-bold py-2 px-6 rounded-lg hover:bg-[#00338d] shadow-[0px_4px_8px_rgba(0,0,0,0.5)]"
            >
              {buttonText}
            </button>
          </div>
        </div>

        {extraInfo.length > 0 && (
          <>
            <hr className="border-t border-gray-400 mt-4 mb-2" />
            <div className="grid grid-cols-3 gap-2 text-center">
              {extraInfo.map((info, i) => (
                <div key={i}>
                  <p className="text-[#022351] font-bold">{info.title}</p>
                  <p className="text-[#022351] text-sm">{info.subtitle}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
